import React, { memo } from "react";

import { ShowcaseIntro } from "ui/components/Showcase";

import {
  TIRE_SET_MOUNT_INTRO_TEXTS,
  TIRE_SET_MOUNT_OLD_SET_STEP,
  TIRE_SET_MOUNT_SUMMARY_STEP,
  TIRE_SET_MOUNT_VEHICLE_STEP,
} from "./consts";
import MountOldSetScene from "./scenes/MountOldSetScene";
import MountSummaryScene from "./scenes/MountSummaryScene";
import MountVehicleScene from "./scenes/MountVehicleScene";
import { TireSetMountIntroProps, TireSetMountSceneProps } from "./types";

/** Scena za korak montaže seta guma. */
const STEP_SCENES: Record<number, React.FC<TireSetMountSceneProps>> = {
  [TIRE_SET_MOUNT_VEHICLE_STEP]: MountVehicleScene,
  [TIRE_SET_MOUNT_OLD_SET_STEP]: MountOldSetScene,
  [TIRE_SET_MOUNT_SUMMARY_STEP]: MountSummaryScene,
};

/** Lijevi panel montaže: set guma putuje sa skladišta na vozilo, a stari set na skladište. */
const TireSetMountIntro: React.FC<TireSetMountIntroProps> = ({ stepCurrent, stepCount, ...sceneProps }) => {
  const stepKey = STEP_SCENES[stepCurrent] ? stepCurrent : TIRE_SET_MOUNT_VEHICLE_STEP;
  const Scene = STEP_SCENES[stepKey];
  const text = TIRE_SET_MOUNT_INTRO_TEXTS[stepKey];
  // Nazivi se razrješavaju tek pri ulasku u potvrdu; nakon povratka i promjene odabira bili bi zastarjeli.
  const props: TireSetMountSceneProps =
    stepKey === TIRE_SET_MOUNT_SUMMARY_STEP
      ? sceneProps
      : { currentSet: sceneProps.currentSet, formValues: sceneProps.formValues };

  return (
    <ShowcaseIntro
      sceneKey={stepKey}
      title={text.title}
      description={text.description}
      stepCurrent={stepKey}
      stepCount={stepCount}
    >
      <Scene {...props} />
    </ShowcaseIntro>
  );
};

export default memo(TireSetMountIntro);
